<template>
  <div class="[ c-cookie-banner__footer ]">
    <ul class="[ c-cookie-banner__footer-list ]">
      <li class="[ c-cookie-banner__list-item ]">
        <a v-on:click="goToInfoPage()" v-html="$t('banner.footer.dataSecure')"/>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    goToInfoPage: function () {
      this.$emit('goto_info')
    }
  }
}
</script>

<style scoped>

</style>
